import Result from '../../Layouts/Result/Result'
import QuizLayout from '../../Layouts/Quiz/Quiz'
import { useNavigate } from 'react-router-dom'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import './Quiz.css'

const Quiz = () => {
  const navigate = useNavigate()
  const quiz_state = useSelector((state) => state.quiz.value)

  useEffect(() => {
    if (quiz_state === 'not-ready') {
      navigate('/')
      return
    }
  }, [])

  return (
    <>
      {quiz_state === 'in-process' && <QuizLayout />}
      {quiz_state === 'finished' && <Result />}
    </>
  )
}

export default Quiz
